'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import { isPublicRoute } from '@/lib/utils/route-utils';
import { AuthErrorBoundary } from './AuthErrorBoundary';

interface RouteAwareErrorBoundaryProps {
  children: React.ReactNode;
  fallbackComponent?: React.ReactNode;
  maxRecoveryAttempts?: number;
  withSuspense?: boolean;
}

/**
 * An error boundary that adapts its behavior based on the current route
 * Uses more lenient error handling for public routes
 */
export function RouteAwareAuthErrorBoundary(props: RouteAwareErrorBoundaryProps) {
  const pathname = usePathname();
  const isPublic = isPublicRoute(pathname);
  
  // For public routes, use a simplified error boundary with public route mode enabled
  if (isPublic) {
    return (
      <AuthErrorBoundary
        {...props}
        maxRecoveryAttempts={1} // Fewer recovery attempts on public routes
        publicRouteMode={true}  // Enable public route mode
      />
    );
  }
  
  // For protected routes, use the standard error boundary
  return <AuthErrorBoundary {...props} />;
}